import React, { useEffect, useState } from 'react'
import { DropDownList ,ComboBox} from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import {getPortfolioListAction} from '../actions/portfolioListAction'
import { useDispatch, useSelector } from 'react-redux';

export const PortfoliosDropDown = (props) => {
    const [portfolioList,setPortfolioList] =useState([]);   
   // const [currentPortfolio,setCurrentPortfolio] =useState({});
    const defaultItem="--Select the portfolio--";
    const dispatch= useDispatch();
    const getPortfolioList = useSelector(state=>state?.portfolioList?.portfolioList);

    useEffect(()=>{
      dispatch(getPortfolioListAction());
    },[])

    useEffect(()=>{
    setPortfolioList(getPortfolioList)
    },[getPortfolioList]);

    const PortfolioDropDownChanged=(e)=>{
       // setCurrentPortfolio(()=>e.value);
        props.DropDownListChanged && props.DropDownListChanged(e);
    }
    const filteredData = (filter) => {
      const DataToBeFiltered=getPortfolioList
      return filterBy(DataToBeFiltered, filter);
    };
    const filterChange = async (event) => {
      setPortfolioList(filteredData(event.filter));
    };
    portfolioList.sort((a, b) => {
        return a.Name.localeCompare(b.Name);
    });

  return (
    <div>
          <ComboBox data={portfolioList} className='SBADropDown' dataItemKey='PortfolioId' textField='Name' onChange={PortfolioDropDownChanged} filterable={true} sortable={false} placeholder={defaultItem} onFilterChange={filterChange} clearButton={false}/>
    </div>
  )
}

